<template>

  <div id="servicos">

    <section class="d-flex align-items-center como-funciona">

        <div class="container">

          <div class="section-title" data-aos="fade-up">
            <div class="row">
              <h1 data-aos="fade-up">Conheça nos serviços</h1>
              <h5 class="mb-5" data-aos="fade-up" data-aos-delay="400">Soluções pensadas para você ganhar mais tempo crescendo seu negócio.</h5>
            </div>

            <div class="row">
              <div class="col-md-6 d-flex align-items-stretch mb-4 gap-5" data-aos="fade-left" data-aos-delay="300">

                <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
                  <!--
                  <div class="icon-number">1Abertura de empresa</div>
                  -->
                  <div class="image d-flex justify-content-center mb-4 " data-aos="fade-right" data-aos-delay="150">
                    <img src="../assets/img/abertura-empresas.jpg" alt="" class="img-fluid" style="width: 370px; height: 233px">
                  </div>
                  <h4 class="title"><strong>Abertura de empresa</strong></h4>
                  <p class="description">Abrir uma empresa no Brasil é extremamente burocrático, na maioria das vezes, os processos são demorados e existem várias etapas em que podem “travar”. Uma ótima maneira de evitar a papelada, é contar com a assistência de um profissional.</p>
                </div>
              </div>
              <!--
              <div class="col-md-6 d-flex align-items-stretch mb-4" data-aos="fade-left" data-aos-delay="300">
                <div class="icon-box justify-content-center" data-aos="fade-up" data-aos-delay="200">
                  <div class="image d-flex justify-content-center mb-4" data-aos="fade-right" data-aos-delay="150">
                    <img src="../assets/img/assessoria-gestao-financeira.jpg" alt="" class="img-fluid" style="width: 370px; height: 233px;">
                  </div>
                  <h4 class="title"><strong>Assessoria proativa para gestão financeira</strong></h4>
                  <p class="description">Uma gestão financeira eficiente é um dos pilares essenciais para o sucesso de uma empresa. Com ela é possível melhorar os resultados e aumentar o valor do patrimônio por meio da geração de lucro líquido proveniente das atividades operacionais. Para isso é necessário planejamento e organização.</p>
                </div>
              </div>
              -->
              <div class="col-md-6 d-flex align-items-stretch mb-4 gap-4" data-aos="fade-left" data-aos-delay="300">
                <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
                  <div class="image d-flex justify-content-center mb-4" data-aos="fade-right" data-aos-delay="150">
                    <img src="../assets/img/processamento-folha-pagamento.jpg" alt="" class="img-fluid" style="width: 370px; height: 233px;">
                  </div>
                  <h4 class="title"><strong>Processamento da folha de pagamentos</strong></h4>
                  <p class="description">A folha de pagamento é o espelho das informações e atividades trabalhistas de cada funcionário. Dentro de uma empresa, é um dos principais processos burocráticos e está totalmente ligado à gestão financeira. É necessário organização e entendimento.</p>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 d-flex align-items-stretch mb-4 gap-4" data-aos="fade-left" data-aos-delay="300">
                <div class="icon-box justify-content-center" data-aos="fade-up" data-aos-delay="200">
                  <div class="image d-flex justify-content-center mb-4" data-aos="fade-right" data-aos-delay="150">
                    <img src="../assets/img/documentos-para-licitacao.jpg" alt="" class="img-fluid" style="width: 370px; height: 233px;">
                  </div>
                  <h4 class="title"><strong>Documentos para licitação</strong></h4>
                  <p class="description">A organização de documentos para licitação é fundamental para que o licitante tenha sucesso nos processos de licitações, mas pode ser burocrática e extremamente estressante. A ajuda de um profissional pode facilitar e acelerar tais processos.</p>
                </div>
              </div>
              <div class="col-md-6 d-flex align-items-stretch mb-4 gap-4" data-aos="fade-left" data-aos-delay="300">
                <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
                  <div class="image d-flex justify-content-center mb-4" data-aos="fade-right" data-aos-delay="150">
                    <img src="../assets/img/assessoria-para-planejamento-tributario.jpg" alt="" class="img-fluid" style="width: 370px; height: 233px;">
                  </div>
                  <h4 class="title"><strong>Assessoria para planejamento tributário</strong></h4>
                  <p class="description">Planejamento tributário é a gestão do pagamento de tributos de uma empresa e também o estudo de maneiras de reduzir legalmente a carga tributária que incide sobre ela. O objetivo é diminuir as despesas, reduzindo o número de tributos pagos que incidem sobre o seu negócio.</p>
                </div>
              </div>
              <!--
              <div class="col-md-6 d-flex align-items-stretch mb-4 gap-4" data-aos="fade-left" data-aos-delay="300">
                <div class="icon-box justify-content-center" data-aos="fade-up" data-aos-delay="200">
                  <div class="image d-flex justify-content-center mb-4" data-aos="fade-right" data-aos-delay="150">
                    <img src="../assets/img/certificado-digital-siga.png" alt="" class="img-fluid" style="width: 370px; height: 233px;">
                  </div>
                  <h4 class="title"><strong>Certificado digital</strong></h4>
                  <p class="description">A Siga é licenciada para facilitar a emissão do Certificado Digital para sua empresa. Ele funciona como um carimbo virtual que garante assinaturas de qualquer documento em qualquer lugar.</p>
                </div>
              </div>
              -->
            </div>

            <div class="row">
              <div class="col-md-6 d-flex align-items-stretch mb-4 gap-4" data-aos="fade-left" data-aos-delay="300">
                <div class="icon-box justify-content-center" data-aos="fade-up" data-aos-delay="200">
                  <div class="image d-flex justify-content-center mb-4" data-aos="fade-right" data-aos-delay="150">
                    <img src="../assets/img/imposto-renda-siga.png" alt="" class="img-fluid" style="width: 370px; height: 233px;">
                  </div>
                  <h4 class="title"><strong>Imposto de Renda</strong></h4>
                  <p class="description">Oferecemos um serviço personalizado para a declaração do Imposto de Renda. Nossa equipe especializada garante a preparação de todos os documentos necessários em conformidade com as exigências legais, maximizando os benefícios fiscais e minimizando os riscos de malha fina.</p>
                </div>
              </div>
              <div class="col-md-6 d-flex align-items-stretch mb-4 gap-4" data-aos="fade-left" data-aos-delay="300">
                <div class="icon-box justify-content-center" data-aos="fade-up" data-aos-delay="200">
                  <div class="image d-flex justify-content-center mb-4" data-aos="fade-right" data-aos-delay="150">
                    <img src="../assets/img/orientacao-juridica-siga.png" alt="" class="img-fluid" style="width: 370px; height: 233px;">
                  </div>
                  <h4 class="title"><strong>Orientação Jurídica</strong></h4>
                  <p class="description">Fornecemos um serviço de orientação jurídica especializada para empresas e indivíduos, incluindo regularização fiscal, análise de contratos, resolução de disputas e compliance. Garanta segurança e conformidade legal com nossa assessoria completa.</p>
                </div>
              </div>
            </div>
          </div>

        </div>

    </section>

  </div>

</template>

<script>
export default {
  name: 'ComoComp'
}
</script>

<style scoped lang="scss">

.como-funciona {
  background-color: $como-funciona-bg-color;
  padding-top: 0;
  padding: 5vh 1vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

img {
  border-radius: 2%;
  width: 98%;
}

.como-funciona .icon-box {
  padding: 30px;
  position: relative;
  overflow: hidden;
  background: $bg-base;
  box-shadow: 0 0 29px 0 rgba(68, 88, 144, 0.12);
  box-shadow: $como-funciona-icon-box-box-shadow;
  transition: box-shadow 0.3s ease;
  border-radius: 8px; /* 40px; */
  z-index: 1;
}

.como-funciona .icon-number {
  font-family: $font-family-base;
  font-weight: 700;
  font-size: 28px;
  margin: 0 auto 20px auto;
  padding-top: 6px;
  display: inline-block;
  text-align: center;
  letter-spacing: 1px;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  transition: 0.5s;
  color: $btn-default-color;
  background: $btn-default-bg;
  border: 2px solid $btn-default-bg;
}

.como-funciona .icon-number:hover {
  transition: box-shadow 0.3s ease;
  box-shadow: 0px 0px 0px 7px $como-funciona-icon-number-hover;
}

.como-funciona .icon i {
  font-size: 36px;
  line-height: 1;
  color: $bg-base;
}

.como-funciona .title {
  font-weight: 700;
  margin-bottom: 15px;
  font-size: 18px;
}

.como-funciona .description {
  font-size: 15px;
  line-height: 28px;
  margin-bottom: 0;
}

#como-funciona img {
  border-radius: 2%;
}

@media (max-width: 1024px) {
  .como-funciona.image {
    text-align: center;
  }

  .como-funciona.image img {
    max-width: 70%;
  }
}

@media (max-width: 667px) {
  .como-funciona.image img {
    max-width: 100%;
  }
}
</style>
